<template>
    <el-row class="addQuestion">
        <el-row>
            <el-card class="card">
                <el-row slot="header" class="clearfix">
                    <el-page-header @back="goBack" content="修改问题"></el-page-header>
                </el-row>
                <el-row>
                    <el-row class="formC" type="flex">
                        <el-col>
                            <el-form :model="questForm" ref="questForm" label-position="right" size="small">
                                <el-form-item label="问题题目：" label-width="100px" prop="title">
                                    <el-input v-model="questForm.title"></el-input>
                                </el-form-item>
                                <el-form-item label="工单类型：" label-width="100px" prop="type">
                                    <el-select v-model="questForm.type">
                                      <el-option v-for="item in datatype" :label="item.text" :value="item.value" :key="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="型号：" label-width="100px" prop="goods_model">
                                    <el-input v-model="questForm.goods_model"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="摘要：" label-width="100px" prop="description">
                                    <el-input type="textarea" v-model="questForm.description"></el-input>
                                </el-form-item> -->
                                <el-form-item class="editor" label="详解：" label-width="100px" prop="detail">
                                    <!-- <el-input v-model="questForm.detail"></el-input> -->
                                    <quill-editor ref="myQuillEditor" v-model="questForm.detail" :options="editorOption"></quill-editor>
                                </el-form-item>
                                <el-form-item class="fileList" label="文件：" label-width="100px">
                                    <div class="fileListContent">
                                        <div class="items" v-for="(item,index) in file_list" :key="item.id">
                                            <div class="imgs">
                                              <img v-if="item.url.split('.')[1] == 'txt'" src="../assets/filetype/txt.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'pdf'" src="../assets/filetype/pdf.png"  alt="">
                                              <img v-if="item.url.split('.')[1] == 'ppt' || item.url.split('.')[1] == 'pptx'" src="../assets/filetype/ppt.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'xls' || item.url.split('.')[1] == 'xlsx'" src="../assets/filetype/excel.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'doc' || item.url.split('.')[1] == 'docx'" src="../assets/filetype/word.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'mp4' || item.url.split('.')[1] == 'mov' || item.url.split('.')[1] == 'ogg' || item.url.split('.')[1] == 'webm'"  src="../assets/filetype/video.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'avi'" src="../assets/filetype/avi.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == '7z' || item.url.split('.')[1] == 'rar'" src="../assets/filetype/zip.png" alt="">
                                              <i class="el-icon-close" @click="delateFile(item,index)"></i>
                                            </div>
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item v-show="false" prop="uploadImg" label="上传图片">
                                      <el-upload
                                        :action="action"
                                        header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                                        list-type="picture-card"
                                        :auto-upload="true"
                                        :file-list="filsList"
                                        :limit="9"
                                        
                                        :before-upload="beforeAvatarUpload"
                                        :on-change="imgHandleChange"
                                        :on-success="imgSuccess"
                                        :on-remove="imgRemove"
                                        ref="pictureUpload"
                                        >
                                          <i slot="default" class="el-icon-plus"></i>
                                          <div slot="file" slot-scope="{file}">
                                            <img
                                              class="el-upload-list__item-thumbnail"
                                              :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                              <span
                                                class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)"
                                              >
                                                <i class="el-icon-zoom-in"></i>
                                              </span>
                                              <span
                                                v-if="!disabled"
                                                class="el-upload-list__item-delete"
                                                @click="imgHandleRemove(file)"
                                              >
                                                <i class="el-icon-delete"></i>
                                              </span>
                                            </span>
                                          </div>
                                      </el-upload>
                                      <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                      </el-dialog>
                                </el-form-item>
                                <el-form-item prop="uploadFile" label="视频/文件">
                                      <el-upload
                                        ref="dmtUploadFile"
                                        class="upload-demo"
                                        :action="action"
                                        header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                                        :auto-upload="true"
                                        :on-preview="fileHandlePreview"
                                        :on-remove="fileHandleRemove"
                                        multiple
                                        :limit="3"
                                        :before-upload="beforeFileUpload"
                                        :on-exceed="fileHandleExceed"
                                        :on-change="fileHandleChange"
                                        :on-success="fileSuccess"
                                        accept="doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi"
                                        :file-list="fileList2">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi文件，且不超过500kb</div>
                                      </el-upload>
                                </el-form-item>
                                <el-form-item class="bytn">
                                   <el-button type="primary" :loading="isLoading" @click="submitForm('ruleForm')">提交</el-button>
                                 </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </el-row>
                <div class="updateTable">
                    <div class="titTop">修改记录</div>
                    <el-divider></el-divider>
                    <div class="mains" v-for="item in updateTable" :key="item.id">
                        <div class="title">
                            <span>{{ item.create_time }}</span>
                            <span class="sp">{{ item.update_person_name }}</span>
                        </div>
                        <div class="content" v-for="ele in item.contents" :key="ele.id">
                            <div class="item">将{{ ele.update_target }}的“{{ ele.old_content }}”修改为“{{ ele.new_content }}”</div>
                        </div>
                    </div>
                </div>
            </el-card>
        </el-row>
    </el-row>
</template>

<script>
import { getOrderType,reviseQs,removeAttach, quesDetail,updateTable } from '../utils/api'
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  // ["link", "image"],
  ["link"],
  ["clean"]
];
export default {
  components: {
    quillEditor
  },
  props: {},
  data() {
    return {
        id:"",
        isLoading:false,
        file_list:[],
        filsList:[],
        fileList2:[],
        imgList:[],
        dialogImageUrl:'',
        dialogVisible: false,
        disabled: false,
        // action:'https://dev.ebyte.com/open/api/v1/attach/uploader?user_token='+localStorage.getItem('user_token'),
        action:localStorage.getItem('uploadUrl')+localStorage.getItem('user_token'),
        questForm:{
            detail: "NTT4ky7q8h",
            goods_model: "I4gunzooWz",
            title: "bNPuLw43Ou",
            type: "jOyiqWn1Wl",
            description:''
        },
        datatype:[],
        editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector("input[name='file']").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        },
        realFileList:"",
        updateTable:[],
        urlHerf:localStorage.getItem('urlHerf')
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack(){
        this.$router.go(-1)
    },
    //获取工单类型
    getOrType() {
      var that = this
      getOrderType()
        .then(res => {
          console.log(res, '工单类型');
          if(res.message.status == 'success'){
            that.datatype = []
            res.data.forEach(item => {
            that.datatype.push({ text: item.type, value: item.type })
          })
          }else{
            that.$message.error(res.message.text)
          }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },

    //图片上传
    //移除图片
    imgHandleRemove(file) {
      console.log(file);
      console.log('12123123');
      var that = this
      let uploadFiles = that.$refs.pictureUpload.uploadFiles
      for (var i = 0; i < uploadFiles.length; i++) {
        if (uploadFiles[i]['url'] == file.url) {
          uploadFiles.splice(i, 1)
        }
      }
      that.imgList.forEach((item,index)=>{
        if(item == file.response.data[0].url){
          that.imgList.splice(index,1)
        }
      })
    },
    //上传图片限制
    beforeAvatarUpload(file){
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        return  isLt5M;
    },
    imgRemove(file, fileList){
      console.log(file,'imgRemove');
      console.log(fileList,'fileListimgRemove');
    },
    //放大图片
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    // 图片状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    imgHandleChange(file){
        // console.log(file,'asdasasd');
    },
    //图片上传成功的钩子
    imgSuccess(res, file, fileList){
        console.log(res,'res上传图片成功的返回');
        var that = this
        if(res.message.status == 'success'){
          that.imgList.push(res.data[0].url)
          that.$message.success('上传成功')
        }else{
          that.$message.error('上传失败')
          that.$refs.pictureUpload.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
        }
        let quill = that.$refs.myQuillEditor.quill
        let range = quill.getSelection()
        let length = range.index;
        quill.insertEmbed(length,'image',that.urlHerf+res.data[0].url)
        quill.setSelection(length + 1)
        console.log(that.questForm.image);
    },

    //文件上传
    fileHandlePreview(file){
      console.log(file);
    },
    //文件限制
    beforeFileUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 7;
      // if(!isLt7M){
      //   this.$message.error('上传文件大小不能超过 7MB!')
      //   return isLt7M
      // }
    },
    fileHandleRemove(file, fileList){
      var that = this
      that.fileList2.forEach((item,index)=>{
        if(item == file.response.data[0].url){
          that.fileList2.splice(index,1)
        }
      })
    },
    fileBeforeRemove(file, fileList){
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //超出文件限制
    fileHandleExceed(files, fileList){
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    fileHandleChange(file){
      console.log(file,'文件');
    },
    fileSuccess(res, file, fileList){
      var that = this
      if(res.message.status == 'success'){
          that.fileList2.push(res.data[0].url)
      }else{
        that.$message.error(res.message.text)
        console.log( that.fileList2,'that.fileList2');
        that.$refs.dmtUploadFile.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
      }
    },


    //提交工单
    submitForm(){
        var that = this
        that.isLoading = true
        var str = ""
        that.file_list.forEach(val=>{
        str += val.url + ','
        })
        if(that.fileList2.length !== 0){
          that.fileList2.forEach(val=>{
            str += val + ','
          })
        }
        that.realFileList = str
        console.log(that.realFileList,'that.realFileList');
        var params = {
            id:that.questForm.id,
            type:that.questForm.type,
            goods_model:that.questForm.goods_model,
            title:that.questForm.title,
            description:that.questForm.description,
            detail:that.questForm.detail,
            file: that.realFileList,
            image:that.imgList.join(','),
        }
        reviseQs(params)
        .then(res=>{
            console.log(res,'修改问题');
            if(res.message.status == 'success'){
                that.$message.success(res.message.text)
                that.$refs['questForm'].resetFields();
                that.$refs['pictureUpload'].uploadFiles = []
                that.fileList2 = []
                that.imgList = []
                that.$router.go(-1)
                that.isLoading = false
            }else
                that.$message.error(res.message.text)
                that.isLoading = false
        })
        .catch(err=>{
            that.$message.error(err)
            that.isLoading = false
            console.log(err,'err');
        })

    },
    qsInit(){
        this.questForm = this.$route.params.row
        var params = {
          id : this.questForm.id
        }
        var that = this
        quesDetail(params)
        .then(res=>{
          console.log(res,"问题库详情返回的数据");
          if(res.message.status == 'success'){
            that.file_list = res.data.attach_file_info
          }else{
            this.$message.error(res.message.text)
          }
          console.log(that.file_list,'that.file_list');
        })
        .catch(err=>{
          console.log(err,'err');
        })
    },
    //删除附件
    delateFile(item,index){
      this.file_list.splice(index,1);
    },
    //获取修改记录
    getupdateTable(){
            var that = this
            console.log(that.id,'that.id');
            var params = {
                question_id:that.questForm.id
            }
            updateTable(params)
            .then(res=>{
                console.log(res,'修改记录');
                if(res.message.status == 'success'){
                    that.updateTable = res.data
                    that.updateTable.forEach(item=>{
                        item.create_time = that.getTimeship(item.create_time)
                    })
                }
            })
            .catch(err=>{
                console.log(err,'err');
            })
        }

  },
  created() {},
  mounted() {},
  activated(){
    this.qsInit();
    this.getOrType();
    this.getupdateTable()
  }
};
</script>
<style lang="scss" scoped>
.addQuestion{
    .bytn{
        text-align: center;
        button{
            width: 200px;
        }
    }
    .editor{
      height: 400px;
      .quill-editor{
          min-height: 300px;
          max-height: 300px;
          height: 300px;
      }
    }
}

.formC{
  .fileList{
    .fileListContent{
      display: flex;
      .items{
        margin-left: 10px;
        width: 60px;
        .imgs{
          position: relative;
          img{
            width: 100%;
          }
          i{
            position: absolute;
            top: 0;
            right: 0;
            font-size: 16px;
            background: #fff;
          }
          i:hover{
            color:red;
            cursor: pointer;
          }
        }
        .name{
          // width: 100%;
          font-size: 12px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
}

.updateTable{
    width: 100%;
    height: 100%;
    margin-top: 50px;

    .titTop{
        font-size: 18px;
        color: #303133;
    }

    .mains{
        width: 100%;
        margin-top: 20px;
        .title{
            color: #666;
            font-weight: 600;
            font-size: 16px;
            .sp{
                margin-left: 10px;
            }
        }
        .content{
            margin-top: 10px;
            font-size: 14px;
            color: #666;
            overflow-x: scroll;
        }
    }
}
</style>